import React from 'react';
const testimonials = [{
  name: 'Anna M.',
  location: 'Bayern 🇩🇪',
  role: 'Sportlehrerin',
  quote: 'Ich habe endlich eine klare Struktur für das ganze Schuljahr. Besonders die fertigen Stunden sparen mir unglaublich viel Zeit.',
  initials: 'AM'
}, {
  name: 'Markus R.',
  location: 'Nordrhein-Westfalen 🇩🇪',
  role: 'Lehrer',
  quote: 'Für Vertretung und spontane Stunden ist das Paket Gold wert. Ich muss nicht mehr improvisieren.',
  initials: 'MR'
}, {
  name: 'Laura K.',
  location: 'Niedersachsen 🇩🇪',
  role: 'Referendarin',
  quote: 'Die Bewertungsraster und Bonusmaterialien machen den Unterschied. Es fühlt sich nicht wie eine Ideensammlung an, sondern wie ein echtes System.',
  initials: 'LK'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-229">
      <div className="max-w-6xl mx-auto" data-id="element-230">
        <div className="text-center mb-12 sm:mb-16" data-id="element-231">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-232">
            Was sagen andere Lehrkräfte?
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-233">
            <span className="text-secondary text-lg" data-id="element-234">⭐⭐⭐⭐⭐</span>
            <span className="text-text-sec font-medium" data-id="element-235">
              Stimmen von Sportlehrern aus ganz Deutschland
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-236">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-main rounded-2xl p-6 border border-border-light shadow-sm flex flex-col" data-id="element-237">
              <div className="flex items-center gap-2 mb-4" data-id="element-238">
                <span className="text-secondary text-sm" data-id="element-239">⭐⭐⭐⭐⭐</span>
              </div>
              <p className="text-text-main text-base leading-relaxed mb-6 flex-grow italic" data-id="element-240">
                „{t.quote}“
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-241">
                <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-242">
                  {t.initials}
                </div>
                <div data-id="element-243">
                  <p className="text-text-main font-bold text-sm" data-id="element-244">
                    {t.name} — {t.role}
                  </p>
                  <p className="text-text-sec text-xs" data-id="element-245">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}